import { removeDashes } from 'utils/form'
import { ADDRESS_FIELD_NAMES } from './constants'

export const getNormalizedAddress = addressModel => Object.entries(addressModel).reduce((acc, [key, value]) => {
  if (key === ADDRESS_FIELD_NAMES.postalCode) {
    return {
      ...acc,
      [key]: removeDashes(value),
    }
  }
  return {
    ...acc,
    [key]: value,
  }
}, {})
